module.exports = __webpack_public_path__ + "assets/img/why-us.eca37e65.jpg";